"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadElection = loadElection;
const schema_1 = require("@kalkulacka-one/schema");
const utilities_1 = require("../utilities/index.js");
const fetch_file_1 = require("./fetch-file");
const url_builders_1 = require("./url-builders");
async function loadElection({ endpoint, group }) {
    const raw = await (0, fetch_file_1.fetchFile)({ url: (0, url_builders_1.buildDataUrl)({ endpoint, key: group, resourcePath: "election.json" }) });
    return (0, utilities_1.parseWithSchema)({ data: raw, schema: schema_1.electionSchema });
}
